import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';

const DashboardContainer = styled.div`
  min-height: 100vh;
  background-color: #f8f9fa;
  font-family: 'Noto Sans Thai', sans-serif !important;
  overflow-x: hidden;
  * {
    font-family: 'Noto Sans Thai', sans-serif !important;
    font-weight: normal;
    color: #666666;
  }
`;

const Header = styled.div`
  background: white;
  padding: 16px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  
  @media (max-width: 480px) {
    padding: 16px 12px;
    margin: 0;
    max-width: 100%;
  }
`;

const HeaderLeft = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const Logo = styled.img`
  width: 32px;
  height: 32px;
  object-fit: contain;
`;

const HeaderTitle = styled.h1`
  font-size: 18px;
  font-weight: bold;
  color: #666;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const ProfileContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
`;

const ProfileImage = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
`;

const NotificationContainer = styled.div`
  position: relative;
  cursor: pointer;
  transition: transform 0.2s ease;
  margin-right: 8px;

  &:hover {
    transform: scale(1.1);
  }
`;

const NotificationBellIcon = styled.div`
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' fill='%23666666'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

const NotificationBadge = styled.div`
  position: absolute;
  top: -6px;
  right: -6px;
  background-color: #ff4444;
  color: white;
  border-radius: 50%;
  width: 16px;
  height: 16px;
  font-size: 10px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: 'Noto Sans Thai', sans-serif !important;
  min-width: 16px;
  padding: 0 2px;
`;

const ProfileName = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #666;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const Content = styled.div`
  padding: 0;
  max-width: 100%;
  margin: 0;
`;

const TabContainer = styled.div`
  display: flex;
  background-color: #f8f9fa;
  border-bottom: 1px solid #e1e5e9;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  
  @media (max-width: 480px) {
    margin: 0;
    max-width: 100%;
  }
`;

const Tab = styled.div`
  padding: 12px 5px;
  text-align: center;
  font-size: 13px;
  font-weight: bold;
  color: ${props => props.active ? 'white' : '#B0B0B0'};
  background-color: ${props => props.active ? '#00BBD3' : '#F2F2F2'};
  cursor: pointer;
  transition: all 0.3s ease;
  font-family: 'Noto Sans Thai', sans-serif !important;
  line-height: 1.2;
  white-space: nowrap;
  flex: 1;
  min-width: 0;

  ${props => {
    if (props.children === 'สุขภาพของคุณ') {
      return `
        @media (min-width: 481px) {
          width: 152px;
          flex: none;
        }
      `;
    } else if (props.children === 'ผลตรวจรวม') {
      return `
        @media (min-width: 481px) {
          width: 120px;
          flex: none;
        }
      `;
    } else if (props.children === 'ผลตรวจเปรียบเทียบ') {
      return `
        @media (min-width: 481px) {
          width: 168px;
          flex: none;
        }
      `;
    }
    return '';
  }}

  @media (max-width: 480px) {
    font-size: 11px;
    padding: 12px 4px;
  }

  &:hover {
    background-color: ${props => props.active ? '#00BBD3' : '#e9ecef'};
  }
`;

const SectionContainer = styled.div`
  padding: 24px 16px;
  max-width: 480px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 480px) {
    padding: 24px 12px;
    margin: 0;
    max-width: 100%;
  }

  @media (max-width: 415px) {
    padding: 20px 10px;
  }

  @media (max-width: 375px) {
    padding: 16px 8px;
  }
`;

const SectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 24px;
`;

const SectionTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #666666;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const AddButton = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: #00BBD3;
  color: white;
  border: none;
  font-size: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;

const GridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 32px;

  @media (max-width: 415px) {
    gap: 12px;
  }

  @media (max-width: 375px) {
    gap: 8px;
  }
`;

const GridItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const CardContainer = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 16px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  margin-bottom: 12px;

  @media (max-width: 415px) {
    width: 100px;
    height: 100px;
  }

  @media (max-width: 375px) {
    width: 90px;
    height: 90px;
    border-radius: 12px;
  }
`;

const AddIconContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background-color: white;
  border: 2px solid #e0e0e0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 2;
`;

const AddIcon = styled.div`
  width: 20px;
  height: 20px;
  background-image: url("data:image/svg+xml,%3csvg width='20' height='20' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3e%3cpath d='M12 5v14M5 12h14' stroke='%23e0e0e0' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
`;

// Modal Components
const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const ModalContainer = styled.div`
  background-color: white;
  border-radius: 16px;
  width: 90%;
  max-width: 400px;
  max-height: 80vh;
  overflow-y: auto;
  position: relative;
  animation: modalFadeIn 0.3s ease-out;

  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const ModalHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid #f0f0f0;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const ModalTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #00BBD3;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  font-size: 24px;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    background-color: #f0f0f0;
    border-radius: 50%;
  }
`;

const ModalContent = styled.div`
  padding: 24px;
`;

const ModalText = styled.p`
  font-size: 16px;
  color: #666;
  line-height: 1.5;
  margin-bottom: 24px;
  font-family: 'Noto Sans Thai', sans-serif !important;
  text-align: center;
`;

const ModalButtons = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
`;

const ModalButton = styled.button`
  padding: 12px 24px;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: bold;
  cursor: pointer;
  font-family: 'Noto Sans Thai', sans-serif !important;
  transition: all 0.3s ease;

  &.primary {
    background-color: #00BBD3;
    color: white;

    &:hover {
      background-color: #009bb3;
    }
  }

  &.secondary {
    background-color: #f5f5f5;
    color: #666;

    &:hover {
      background-color: #e0e0e0;
    }
  }
`;

const IconContainer = styled.div`
  width: 120px;
  height: 101px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;

  @media (max-width: 415px) {
    width: 100px;
    height: 81px;
  }

  @media (max-width: 375px) {
    width: 90px;
    height: 71px;
  }
`;

const ItemIcon = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;

  @media (max-width: 415px) {
    width: 65px;
    height: 65px;
  }

  @media (max-width: 375px) {
    width: 55px;
    height: 55px;
  }
`;

const ItemLabel = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  text-align: center;
  font-family: 'Noto Sans Thai', sans-serif !important;
  line-height: 1.2;

  @media (max-width: 415px) {
    font-size: 12px;
  }

  @media (max-width: 375px) {
    font-size: 11px;
  }
`;

const StatusBar = styled.div`
  width: 120px;
  height: 19px;
  background-color: ${props => props.color || '#e9ecef'};
  position: absolute;
  bottom: 0;
  left: 0;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  @media (max-width: 415px) {
    width: 100px;
  }

  @media (max-width: 375px) {
    width: 90px;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`;

const HospitalSection = styled.div`
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #e1e5e9;
`;

const HospitalSectionHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  margin-bottom: 16px;
`;

const HospitalSectionTitle = styled.h2`
  font-size: 18px;
  font-weight: bold;
  color: #666666;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const HospitalAddButton = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: #00BBD3;
  color: white;
  border: none;
  font-size: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
`;

const SleepModalContainer = styled.div`
  background-color: white;
  border-radius: 16px;
  width: 95%;
  max-width: 450px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  animation: modalFadeIn 0.3s ease-out;

  @keyframes modalFadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
`;

const SleepFormContainer = styled.div`
  padding: 24px;
`;

const FormGroup = styled.div`
  margin-bottom: 24px;
`;

const FormLabel = styled.label`
  display: block;
  font-size: 16px;
  font-weight: bold;
  color: #333;
  margin-bottom: 12px;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const DateContainer = styled.div`
  display: grid;
  grid-template-columns: 2fr 2fr 3fr;
  gap: 12px;
`;

const TimeContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const Select = styled.select`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  font-family: 'Noto Sans Thai', sans-serif !important;
  color: #333;
  background-color: white;

  &:focus {
    outline: none;
    border-color: #00BBD3;
  }
`;

const Input = styled.input`
  width: 100%;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  font-family: 'Noto Sans Thai', sans-serif !important;
  color: #333;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #00BBD3;
  }
`;

const Textarea = styled.textarea`
  width: 100%;
  min-height: 80px;
  padding: 12px 16px;
  border: 2px solid #e0e0e0;
  border-radius: 8px;
  font-size: 16px;
  font-family: 'Noto Sans Thai', sans-serif !important;
  color: #333;
  resize: vertical;
  box-sizing: border-box;

  &:focus {
    outline: none;
    border-color: #00BBD3;
  }
`;

const RadioOption = styled.label`
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  font-family: 'Noto Sans Thai', sans-serif !important;
  justify-content: flex-start;
`;

const RadioInput = styled.input`
  margin: 0;
  accent-color: #00BBD3;
`;

const QualityGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;

  & > label:last-child {
    grid-column: 1 / -1;
    justify-self: start;
    max-width: 200px;
  }
`;

const FormActions = styled.div`
  display: flex;
  gap: 12px;
  justify-content: flex-end;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
`;

const HospitalGridContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
  margin-bottom: 24px;

  @media (max-width: 415px) {
    gap: 12px;
  }

  @media (max-width: 375px) {
    gap: 8px;
  }
`;

const HospitalGridItem = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const HospitalCardContainer = styled.div`
  width: 120px;
  height: 120px;
  border-radius: 16px;
  background-color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  position: relative;
  overflow: hidden;
  margin-bottom: 12px;

  @media (max-width: 415px) {
    width: 100px;
    height: 100px;
  }

  @media (max-width: 375px) {
    width: 90px;
    height: 90px;
    border-radius: 12px;
  }
`;

const HospitalIconContainer = styled.div`
  width: 120px;
  height: 101px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: white;

  @media (max-width: 415px) {
    width: 100px;
    height: 81px;
  }

  @media (max-width: 375px) {
    width: 90px;
    height: 71px;
  }
`;

const HospitalItemIcon = styled.img`
  width: 80px;
  height: 80px;
  object-fit: contain;

  @media (max-width: 415px) {
    width: 65px;
    height: 65px;
  }

  @media (max-width: 375px) {
    width: 55px;
    height: 55px;
  }
`;

const HospitalItemLabel = styled.span`
  font-size: 14px;
  font-weight: bold;
  color: #666666;
  text-align: center;
  font-family: 'Noto Sans Thai', sans-serif !important;
  line-height: 1.2;

  @media (max-width: 415px) {
    font-size: 12px;
  }

  @media (max-width: 375px) {
    font-size: 11px;
  }
`;

const HospitalStatusBar = styled.div`
  width: 120px;
  height: 19px;
  background-color: ${props => props.color || '#e9ecef'};
  position: absolute;
  bottom: 0;
  left: 0;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;

  @media (max-width: 415px) {
    width: 100px;
  }

  @media (max-width: 375px) {
    width: 90px;
    border-bottom-left-radius: 12px;
    border-bottom-right-radius: 12px;
  }
`;

const LegendContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
  margin-bottom: 24px;
  padding: 16px;
  background-color: #f8f9fa;
  border-radius: 12px;

  @media (max-width: 415px) {
    gap: 12px;
    padding: 12px;
  }

  @media (max-width: 375px) {
    gap: 8px;
    padding: 10px;
  }
`;

const LegendItem = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 12px;
  color: #666;
  font-family: 'Noto Sans Thai', sans-serif !important;

  @media (max-width: 415px) {
    font-size: 11px;
    gap: 6px;
  }

  @media (max-width: 375px) {
    font-size: 10px;
    gap: 5px;
  }
`;

const LegendDot = styled.div`
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background-color: ${props => props.color};

  @media (max-width: 415px) {
    width: 10px;
    height: 10px;
  }

  @media (max-width: 375px) {
    width: 8px;
    height: 8px;
  }
`;

const AppointmentCard = styled.div`
  position: relative;
  width: 100%;
  height: 153px;
  margin-bottom: 24px;
  cursor: pointer;
  transition: transform 0.3s ease;
  
  &:hover {
    transform: translateY(-2px);
  }
`;

const AppointmentLeftCard = styled.div`
  position: absolute;
  left: 0;
  top: 17px;
  width: 226px;
  height: 118px;
  background: white;
  border-radius: 16px;
  padding: 20px;
  overflow: hidden;
  box-sizing: border-box;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  z-index: 999;

  @media (max-width: 480px) {
    width: calc(100vw - 160px);
    max-width: 210px;
    padding: 14px;
  }

  @media (max-width: 415px) {
    width: calc(100vw - 150px);
    max-width: 200px;
    padding: 12px;
  }

  @media (max-width: 375px) {
    width: calc(100vw - 140px);
    max-width: 190px;
    padding: 12px;
  }
`;

const NotificationBell = styled.div`
  position: absolute;
  top: 12px;
  right: 12px;
  width: 25px;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
`;

const AppointmentContent = styled.div`
  position: relative;
  z-index: 1001;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const AppointmentText = styled.div`
  flex: 1;
`;

const AppointmentTitle = styled.h3`
  font-size: 16px;
  font-weight: bold;
  color: #00BBD3;
  margin: 0 0 8px 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const AppointmentDivider = styled.hr`
  border: none;
  height: 1px;
  background-color: #E8E8E8;
  margin: 8px 0;
  width: 100%;
`;

const AppointmentSubtitle = styled.p`
  font-size: 14px;
  color: #8C8C8C;
  margin: 0 0 4px 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
  line-height: 1.4;
`;

const AppointmentDate = styled.p`
  font-size: 14px;
  color: #8C8C8C;
  margin: 0;
  font-family: 'Noto Sans Thai', sans-serif !important;
`;

const DoctorImageContainer = styled.div`
  position: absolute;
  right: -20px;
  top: 0;
  width: 227px;
  height: 153px;
  z-index: 1;

  @media (max-width: 480px) {
    right: -20px;
    width: 170px;
  }

  @media (max-width: 415px) {
    right: -15px;
    width: 155px;
  }

  @media (max-width: 375px) {
    right: -10px;
    width: 145px;
  }
`;

const DoctorIllustration = styled.img`
  width: 227px;
  height: 153px;
  object-fit: contain;

  @media (max-width: 480px) {
    width: 170px;
    height: auto;
  }

  @media (max-width: 415px) {
    width: 155px;
    height: auto;
  }

  @media (max-width: 375px) {
    width: 145px;
    height: auto;
  }
`;

const DashboardPage = () => {
  const navigate = useNavigate();
  const [notificationCount] = useState(3);
  const [showAddDataModal, setShowAddDataModal] = useState(false);
  const [selectedCardForModal, setSelectedCardForModal] = useState(null);
  const [showSleepModal, setShowSleepModal] = useState(false);
  const [sleepFormData, setSleepFormData] = useState({
    date: new Date().toISOString().split('T')[0],
    hour: new Date().getHours().toString().padStart(2, '0'),
    minute: new Date().getMinutes().toString().padStart(2, '0'),
    duration: '',
    quality: '',
    problems: ''
  });

  const handleNotificationClick = () => {
    navigate('/notifications');
  };

  const healthItems = [
    { icon: './ความดัน.png', label: 'ความดัน', bgColor: '#ff6b6b', statusColor: '#ff6b6b' },
    { icon: './น้ำตาล.png', label: 'น้ำตาล', bgColor: '#ffa726', statusColor: '#ffa726' },
    { icon: './น้ำหนัก.png', label: 'น้ำหนัก', bgColor: '#ffee58', statusColor: '#ffee58' },
    // { icon: './อาหาร.png', label: 'อาหาร', bgColor: '#ffa726', statusColor: '#ffa726' },
    // { icon: './อารมณ์.png', label: 'อารมณ์', bgColor: '#66bb6a', statusColor: '#66bb6a' },
    // { icon: './อาการผิดปกติ.png', label: 'อาการผิดปกติ', bgColor: '#66bb6a', statusColor: '#66bb6a' },
    // { icon: './การออกกำลังกาย.png', label: 'การออกกำลังกาย', bgColor: '#e0e0e0', statusColor: '#e0e0e0' },
    // { icon: './การนอนหลับ.png', label: 'การนอนหลับ', bgColor: '#e0e0e0', statusColor: '#e0e0e0' },
    // { icon: './สูบบุหรี่.png', label: 'สูบบุหรี่ /ดื่มสุรา', bgColor: '#e0e0e0', statusColor: '#e0e0e0' },
    // { icon: './แบบประเมิน1.png', label: 'แบบประเมินความเสี่ยงหลอดเลือดสมอง', bgColor: '#e0e0e0', statusColor: '#e0e0e0' },
    // { icon: './แบบประเมิน2.png', label: 'แบบประเมินความเสี่ยงโรคไต', bgColor: '#e0e0e0', statusColor: '#e0e0e0' }
  ];

  const hospitalItems = [
    { icon: './ไต.png', label: 'ไต', bgColor: '#ff6b6b', statusColor: '#ff6b6b' },
    { icon: './เลือด.png', label: 'ความสมบูรณ์ของเลือด', bgColor: '#ffa726', statusColor: '#ffa726' },
    { icon: './น้ำตาลบวก.png', label: 'น้ำตาลสะสม', bgColor: '#ffee58', statusColor: '#ffee58' },
    { icon: './ไขมัน.png', label: 'ไขมัน', bgColor: '#e0e0e0', statusColor: '#e0e0e0' },
    { icon: './ตับ.png', label: 'ตับ', bgColor: '#e0e0e0', statusColor: '#e0e0e0' },
    { icon: './กรดยูริค.png', label: 'กรดยูริค', bgColor: '#66bb6a', statusColor: '#66bb6a' },
    { icon: './ผลการตรวจปัสสาวะ.png', label: 'ผลการตรวจปัสสาวะ', bgColor: '#e0e0e0', statusColor: '#e0e0e0' },
    { icon: './xray.png', label: 'ผลตรวจเอ็กเรย์', bgColor: '#e0e0e0', statusColor: '#e0e0e0', nonInteractive: true }
  ];

  const handleAddDataClick = (item) => {
    console.log('Add data for:', item.label);
    setSelectedCardForModal(item);
    setShowAddDataModal(true);
  };

  const handleCloseModal = () => {
    setShowAddDataModal(false);
    setSelectedCardForModal(null);
  };

  const handleConfirmAddData = () => {
    if (selectedCardForModal) {
      console.log('Confirmed adding data for:', selectedCardForModal.label);
      // Navigate to appropriate form or handle data addition
      navigate('/daily-health-record');
    }
    handleCloseModal();
  };

  const handleItemClick = (item) => {
    console.log('Clicked:', item.label);

    // ตรวจสอบการคลิกไอคอนการนอนหลับ
    if (item.label === 'การนอนหลับ') {
      setShowSleepModal(true);
      return;
    }

    // ตรวจสอบว่าเป็นการ์ดสีเทาหรือไม่ (ยังไม่มีข้อมูล)
    if (item.bgColor === '#e0e0e0') {
      handleAddDataClick(item);
      return;
    }

    // Navigation สำหรับการ์ดที่มีสี
    if (item.label === 'ความดัน') {
      navigate('/blood-pressure');
    } else if (item.label === 'อาหาร') {
      navigate('/daily-health-record');
    } else if (item.label === 'น้ำตาล') {
      // สร้างหน้าใหม่สำหรับกราฟน้ำตาล (คล้ายกับ blood-pressure)
      console.log('นำไปยังหน้ากราฟน้ำตาล');
      // navigate('/blood-sugar');
    } else if (item.label === 'น้ำหนัก') {
      // สร้างหน้าใหม่สำหรับกราฟน้ำหนัก
      console.log('นำไปยังหน้ากราฟน้ำหนัก');
      // navigate('/weight');
    } else if (item.label === 'อารมณ์') {
      // สร้างหน้าใหม่สำหรับกราฟอารมณ์
      console.log('นำไปยังหน้ากราฟอารมณ์');
      // navigate('/mood');
    } else if (item.label === 'อาการผิดปกติ') {
      // สร้างหน้าใหม่สำหรับกราฟอาการผิดปกติ
      console.log('นำไปยังหน้ากราฟอาการผิดปกติ');
      // navigate('/symptoms');
    }
  };

const handleHospitalItemClick = (item) => {
  console.log('Hospital item clicked:', item.label);

  // ตรวจสอบการ์ดผลตรวจเอ็กเรย์
  if (item.label === 'ผลตรวจเอ็กเรย์') {
    console.log('นำไปยังหน้าผลตรวจเอ็กเรย์');
    navigate('/xray-results');
    return;
  }

  // ตรวจสอบว่าเป็นการ์ดสีเทาหรือไม่ (ยังไม่มีข้อมูล)
  if (item.bgColor === '#e0e0e0') {
    handleAddDataClick(item);
    return;
  }

  // Navigation สำหรับการ์ดที่มีสี (ข้อมูลจากโรงพยาบาล)
  if (item.label === 'ไต') {
    console.log('นำไปยังหน้าผลตรวจไต');
    // navigate('/kidney-results');
  } else if (item.label === 'ความสมบูรณ์ของเลือด') {
    console.log('นำไปยังหน้าผลตรวจเลือด');
    // navigate('/blood-test-results');
  } else if (item.label === 'น้ำตาลสะสม') {
    console.log('นำไปยังหน้าผลตรวจน้ำตาลสะสม');
    // navigate('/hba1c-results');
  } else if (item.label === 'กรดยูริค') {
    console.log('นำไปยังหน้าผลตรวจกรดยูริค');
    // navigate('/uric-acid-results');
  }
  // เพิ่มเงื่อนไขสำหรับไปยังหน้าแบบฟอร์ม
  if (item.label === 'ตรวจจากโรงพยาบาล') {
    navigate('/hospital-checkup');
  }
};

  const handleVaccineClick = () => {
    navigate('/vaccine-notification');
  };

  const handleSleepModalClose = () => {
    setShowSleepModal(false);
    setSleepFormData({
      date: new Date().toISOString().split('T')[0],
      hour: new Date().getHours().toString().padStart(2, '0'),
      minute: new Date().getMinutes().toString().padStart(2, '0'),
      duration: '',
      quality: '',
      problems: ''
    });
  };

  const handleSleepFormChange = (field, value) => {
    setSleepFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleSleepFormSubmit = () => {
    console.log('บันทึกข้อมูลการนอนหลับ:', sleepFormData);
    // ที่นี่สามารถส่งข้อมูลไปยัง API หรือบันทึกลง localStorage
    alert('บันทึกข้อมูลการนอนหลับเรียบร้อยแล้ว');
    handleSleepModalClose();
  };

  const generateDayOptions = () => {
    const days = [];
    for (let i = 1; i <= 31; i++) {
      days.push(<option key={i} value={i.toString().padStart(2, '0')}>{i}</option>);
    }
    return days;
  };

  const generateMonthOptions = () => {
    const months = [
      'มกราคม', 'กุมภาพันธ์', 'มีนาคม', 'เมษายน', 'พฤษภาคม', 'มิถุนายน',
      'กรกฎาคม', 'สิงหาคม', 'กันยายน', 'ตุลาคม', 'พฤศจิกายน', 'ธันวาคม'
    ];
    return months.map((month, index) => (
      <option key={index + 1} value={(index + 1).toString().padStart(2, '0')}>{month}</option>
    ));
  };

  const generateYearOptions = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = currentYear; i >= currentYear - 10; i--) {
      const buddhistYear = i + 543;
      years.push(<option key={i} value={i}>{buddhistYear}</option>);
    }
    return years;
  };

  const generateHourOptions = () => {
    const hours = [];
    for (let i = 0; i < 24; i++) {
      hours.push(<option key={i} value={i.toString().padStart(2, '0')}>{i.toString().padStart(2, '0')}</option>);
    }
    return hours;
  };

  const generateMinuteOptions = () => {
    const minutes = [];
    for (let i = 0; i < 60; i++) {
      minutes.push(<option key={i} value={i.toString().padStart(2, '0')}>{i.toString().padStart(2, '0')}</option>);
    }
    return minutes;
  };

  const handleTabClick = (tab) => {
  if (tab === 'ผลตรวจรวม') {
    navigate('/test-results');
  } else if (tab === 'ผลตรวจเปรียบเทียบ') {
    navigate('/comparison-results');
  }
};

  return (
    <DashboardContainer>
      <Header>
        <HeaderLeft>
          <Logo src="./logo.png" alt="MFU Logo" />
          <HeaderTitle>MFU Wellness Center</HeaderTitle>
        </HeaderLeft>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
          <NotificationContainer onClick={handleNotificationClick}>
            <NotificationBellIcon />
            {notificationCount > 0 && (
              <NotificationBadge>{notificationCount}</NotificationBadge>
            )}
          </NotificationContainer>
          <ProfileContainer onClick={() => navigate('/profile-edit')}>
            <ProfileName>พงษ์ชัย</ProfileName>
            <ProfileImage src="./person.png" alt="Profile" />
          </ProfileContainer>
        </div>
      </Header>

      <Content>
        <TabContainer>
          <Tab active>สุขภาพของคุณ</Tab>
          <Tab onClick={() => handleTabClick('ผลตรวจรวม')}>ผลตรวจรวม</Tab>
          <Tab onClick={() => handleTabClick('ผลตรวจเปรียบเทียบ')}>ผลตรวจเปรียบเทียบ</Tab>
        </TabContainer>

        <SectionContainer>
          <SectionHeader>
            <SectionTitle>บันทึกประจำวัน</SectionTitle>
            <AddButton onClick={() => navigate('/daily-health-record')}>+</AddButton>
          </SectionHeader>

          <GridContainer>
            {healthItems.map((item, index) => (
              <GridItem key={index} onClick={() => handleItemClick(item)}>
                <CardContainer>
                  <IconContainer>
                    <ItemIcon src={item.icon} alt={item.label} />
                  </IconContainer>
                  {item.bgColor === '#e0e0e0' && (
                    <AddIconContainer>
                      <AddIcon />
                    </AddIconContainer>
                  )}
                  <StatusBar color={item.statusColor} />
                </CardContainer>
                <ItemLabel>{item.label}</ItemLabel>
              </GridItem>
            ))}
          </GridContainer>

          <HospitalSection>
            <HospitalSectionHeader>
            <HospitalSectionTitle>ตรวจจากโรงพยาบาล</HospitalSectionTitle>
            <HospitalAddButton onClick={() => navigate('/hospital-checkup')}>+</HospitalAddButton>
            </HospitalSectionHeader>

            <HospitalGridContainer>
              {hospitalItems.map((item, index) => (
                <HospitalGridItem
                  key={index}
                  onClick={() => handleHospitalItemClick(item)}
                  style={{
                    cursor: 'pointer',
                    opacity: 1
                  }}
                >
                  <HospitalCardContainer>
                    <HospitalIconContainer>
                      <HospitalItemIcon src={item.icon} alt={item.label} />
                    </HospitalIconContainer>
                    {item.bgColor === '#e0e0e0' && !item.nonInteractive && (
                      <AddIconContainer>
                        <AddIcon />
                      </AddIconContainer>
                    )}
                    <HospitalStatusBar color={item.statusColor} />
                  </HospitalCardContainer>
                  <HospitalItemLabel>{item.label}</HospitalItemLabel>
                </HospitalGridItem>
              ))}
            </HospitalGridContainer>

            <LegendContainer>
              <LegendItem>
                <LegendDot color="#ff6b6b" />
                <span>อันตราย/เกินเกณฑ์</span>
              </LegendItem>
              <LegendItem>
                <LegendDot color="#ffa726" />
                <span>เกินเกณฑ์</span>
              </LegendItem>
              <LegendItem>
                <LegendDot color="#ffee58" />
                <span>เฝ้าระวัง</span>
              </LegendItem>
              <LegendItem>
                <LegendDot color="#66bb6a" />
                <span>อยู่ในเกณฑ์ปกติ</span>
              </LegendItem>
              <LegendItem>
                <LegendDot color="#e0e0e0" />
                <span>ไม่มีข้อมูล</span>
              </LegendItem>
            </LegendContainer>

            <AppointmentCard onClick={handleVaccineClick}>
              <DoctorImageContainer>
                <DoctorIllustration src="./หมอกำลังฉีดวัคซีน.png" alt="Doctor" />
              </DoctorImageContainer>
              <AppointmentLeftCard>
                <NotificationBell>
                  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
                    <g clipPath="url(#clip0_1014_2621)">
                      <path d="M12.5 0C9.18479 0 6.00537 1.31696 3.66117 3.66117C1.31696 6.00537 0 9.18479 0 12.5C0 15.8152 1.31696 18.9946 3.66117 21.3388C6.00537 23.683 9.18479 25 12.5 25C15.8152 25 18.9946 23.683 21.3388 21.3388C23.683 18.9946 25 15.8152 25 12.5C25 9.18479 23.683 6.00537 21.3388 3.66117C18.9946 1.31696 15.8152 0 12.5 0ZM12.512 6.002C13.334 6.002 14.012 6.679 14.012 7.502C14.012 7.776 13.932 8.03 13.801 8.252C14.4566 8.50722 15.0197 8.95478 15.4162 9.53589C15.8128 10.117 16.0243 10.8045 16.023 11.508C16.023 11.508 16.012 13.14 16.012 14.058C16.012 14.004 16.026 14.108 16.098 14.23C16.17 14.352 16.281 14.502 16.395 14.64C16.622 14.917 16.854 15.143 16.854 15.143C16.9256 15.2124 16.9748 15.3016 16.9953 15.3992C17.0158 15.4968 17.0066 15.5983 16.969 15.6907C16.9314 15.783 16.867 15.862 16.7841 15.9175C16.7013 15.973 16.6037 16.0024 16.504 16.002H14.51C14.5095 16.3237 14.4316 16.6405 14.283 16.9257C14.1344 17.211 13.9193 17.4563 13.656 17.641C13.3072 17.8836 12.8903 18.0091 12.4655 17.9992C12.0407 17.9893 11.6301 17.8446 11.293 17.586C11.0519 17.3985 10.857 17.1582 10.7232 16.8836C10.5893 16.609 10.5202 16.3074 10.521 16.002H8.496C8.39594 16.002 8.29818 15.972 8.21535 15.9159C8.13252 15.8598 8.06844 15.7801 8.03139 15.6871C7.99434 15.5942 7.98603 15.4923 8.00753 15.3945C8.02903 15.2968 8.07936 15.2078 8.152 15.139C8.152 15.139 8.39 14.914 8.623 14.639C8.739 14.501 8.853 14.35 8.926 14.229C8.999 14.107 9.012 14.004 9.012 14.059C9.012 12.963 9.023 11.502 9.023 11.502C9.02645 10.8037 9.23798 10.1223 9.63056 9.54486C10.0231 8.96739 10.579 8.52006 11.227 8.26C11.088 8.03148 11.0137 7.76948 11.012 7.502C11.012 6.679 11.689 6.002 12.512 6.002ZM12.512 7.002C12.23 7.002 12.012 7.22 12.012 7.502C12.012 7.784 12.23 8.002 12.512 8.002C12.794 8.002 13.012 7.784 13.012 7.502C13.012 7.22 12.794 7.002 12.512 7.002ZM12.523 9.004V9.006C12.194 9.00427 11.868 9.06783 11.5638 9.19298C11.2596 9.31813 10.9832 9.50239 10.7507 9.73509C10.5182 9.9678 10.3341 10.2443 10.2092 10.5486C10.0843 10.853 10.021 11.179 10.023 11.508C10.023 11.508 10.012 12.97 10.012 14.058C10.012 14.355 9.898 14.55 9.782 14.744C9.725 14.837 9.656 14.916 9.592 15.002H15.424C15.36 14.914 15.292 14.832 15.236 14.738C15.122 14.545 15.012 14.351 15.012 14.058C15.012 13.132 15.023 11.502 15.023 11.502C15.0254 11.1731 14.9624 10.847 14.8375 10.5428C14.7127 10.2385 14.5286 9.96206 14.296 9.72959C14.0633 9.49713 13.7868 9.31326 13.4824 9.18869C13.178 9.06412 12.8519 9.00134 12.523 9.004ZM11.516 16.002C11.5144 16.185 11.5634 16.3648 11.6575 16.5217C11.7516 16.6786 11.8872 16.8065 12.0493 16.8913C12.2115 16.9761 12.3939 17.0145 12.5764 17.0023C12.759 16.9901 12.9346 16.9277 13.084 16.822C13.2162 16.7299 13.3241 16.6073 13.3986 16.4645C13.4731 16.3217 13.512 16.1631 13.512 16.002H11.516Z" fill="#EB1500"/>
                    </g>
                    <defs>
                      <clipPath id="clip0_1014_2621">
                        <rect width="25" height="25" fill="white"/>
                      </clipPath>
                    </defs>
                  </svg>
                </NotificationBell>
                <AppointmentContent>
                  <AppointmentText>
                    <AppointmentTitle>แจ้งเตือนการฉีดวัคซีน</AppointmentTitle>
                    <AppointmentDivider />
                    <AppointmentSubtitle>วัคซีนไข้หวัดใหญ่</AppointmentSubtitle>
                    <AppointmentDate>ในวันที่ 23/10/2525</AppointmentDate>
                  </AppointmentText>
                </AppointmentContent>
              </AppointmentLeftCard>
            </AppointmentCard>
          </HospitalSection>
        </SectionContainer>
      </Content>

      {/* Add Data Modal */}
      {showAddDataModal && selectedCardForModal && (
        <ModalOverlay onClick={handleCloseModal}>
          <ModalContainer onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle>เพิ่มข้อมูล{selectedCardForModal.label}</ModalTitle>
              <CloseButton onClick={handleCloseModal}>×</CloseButton>
            </ModalHeader>
            <ModalContent>
              <ModalText>
                คุณต้องการเพิ่มข้อมูล{selectedCardForModal.label}หรือไม่?<br />
                ระบบจะนำคุณไปยังหน้าการบันทึกข้อมูลสุขภาพ
              </ModalText>
              <ModalButtons>
                <ModalButton className="secondary" onClick={handleCloseModal}>
                  ยกเลิก
                </ModalButton>
                <ModalButton className="primary" onClick={handleConfirmAddData}>
                  ดำเนินการต่อ
                </ModalButton>
              </ModalButtons>
            </ModalContent>
          </ModalContainer>
        </ModalOverlay>
      )}

      {/* Sleep Modal */}
      {showSleepModal && (
        <ModalOverlay onClick={handleSleepModalClose}>
          <SleepModalContainer onClick={(e) => e.stopPropagation()}>
            <ModalHeader>
              <ModalTitle style={{ color: '#000' }}>การนอนหลับ</ModalTitle>
              <CloseButton onClick={handleSleepModalClose}>×</CloseButton>
            </ModalHeader>
            <SleepFormContainer>
              <FormGroup>
                <FormLabel>วันที่ตรวจ</FormLabel>
                <DateContainer>
                  <Select
                    value={sleepFormData.date.split('-')[2]}
                    onChange={(e) => {
                      const [year, month] = sleepFormData.date.split('-');
                      handleSleepFormChange('date', `${year}-${month}-${e.target.value}`);
                    }}
                  >
                    <option value="">วัน</option>
                    {generateDayOptions()}
                  </Select>
                  <Select
                    value={sleepFormData.date.split('-')[1]}
                    onChange={(e) => {
                      const [year, , day] = sleepFormData.date.split('-');
                      handleSleepFormChange('date', `${year}-${e.target.value}-${day}`);
                    }}
                  >
                    <option value="">เดือน</option>
                    {generateMonthOptions()}
                  </Select>
                  <Select
                    value={sleepFormData.date.split('-')[0]}
                    onChange={(e) => {
                      const [, month, day] = sleepFormData.date.split('-');
                      handleSleepFormChange('date', `${e.target.value}-${month}-${day}`);
                    }}
                  >
                    <option value="">ปี</option>
                    {generateYearOptions()}
                  </Select>
                </DateContainer>
              </FormGroup>

              <FormGroup>
                <FormLabel>เวลาที่บันทึก</FormLabel>
                <TimeContainer>
                  <Select
                    value={sleepFormData.hour}
                    onChange={(e) => handleSleepFormChange('hour', e.target.value)}
                  >
                    <option value="">ชั่วโมง</option>
                    {generateHourOptions()}
                  </Select>
                  <Select
                    value={sleepFormData.minute}
                    onChange={(e) => handleSleepFormChange('minute', e.target.value)}
                  >
                    <option value="">นาที</option>
                    {generateMinuteOptions()}
                  </Select>
                </TimeContainer>
              </FormGroup>

              <FormGroup>
                <FormLabel>ระยะเวลาการนอนหลับ (ชั่วโมง)</FormLabel>
                <Input
                  type="number"
                  min="0"
                  max="24"
                  step="0.5"
                  placeholder="ตัวอย่าง 8"
                  value={sleepFormData.duration}
                  onChange={(e) => handleSleepFormChange('duration', e.target.value)}
                />
              </FormGroup>

              <FormGroup>
                <FormLabel>คุณภาพการนอนหลับ</FormLabel>
                <QualityGrid>
                  <RadioOption>
                    <RadioInput
                      type="radio"
                      name="quality"
                      value="excellent"
                      checked={sleepFormData.quality === 'excellent'}
                      onChange={(e) => handleSleepFormChange('quality', e.target.value)}
                    />
                    ดีมาก
                  </RadioOption>
                  <RadioOption>
                    <RadioInput
                      type="radio"
                      name="quality"
                      value="good"
                      checked={sleepFormData.quality === 'good'}
                      onChange={(e) => handleSleepFormChange('quality', e.target.value)}
                    />
                    ดี
                  </RadioOption>
                  <RadioOption>
                    <RadioInput
                      type="radio"
                      name="quality"
                      value="average"
                      checked={sleepFormData.quality === 'average'}
                      onChange={(e) => handleSleepFormChange('quality', e.target.value)}
                    />
                    ปานกลาง
                  </RadioOption>
                  <RadioOption>
                    <RadioInput
                      type="radio"
                      name="quality"
                      value="poor"
                      checked={sleepFormData.quality === 'poor'}
                      onChange={(e) => handleSleepFormChange('quality', e.target.value)}
                    />
                    แย่
                  </RadioOption>
                  <RadioOption>
                    <RadioInput
                      type="radio"
                      name="quality"
                      value="very-poor"
                      checked={sleepFormData.quality === 'very-poor'}
                      onChange={(e) => handleSleepFormChange('quality', e.target.value)}
                    />
                    แย่มาก
                  </RadioOption>
                </QualityGrid>
              </FormGroup>

              <FormGroup>
                <FormLabel>ปัญหาที่พบ (ถ้ามี)</FormLabel>
                <Textarea
                  placeholder="ระบุ"
                  value={sleepFormData.problems}
                  onChange={(e) => handleSleepFormChange('problems', e.target.value)}
                />
              </FormGroup>

              <FormActions>
                <ModalButton
                  className="primary"
                  onClick={handleSleepFormSubmit}
                  disabled={!sleepFormData.duration || !sleepFormData.quality}
                  style={{ width: '100%' }}
                >
                  บันทึก
                </ModalButton>
              </FormActions>
            </SleepFormContainer>
          </SleepModalContainer>
        </ModalOverlay>
      )}
    </DashboardContainer>
  );
};

export default DashboardPage;